// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"R8-z"};